let logoutCallback = null;

export function setLogoutCallback(cb) {
  logoutCallback = cb;
}

export function callLogout() {
  if (logoutCallback) logoutCallback();
}
